/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a formatted personsGap row
 *
 * @deprecated with EN-4733 & EN-5264
 *
 */
export const PersonsGap = ({ title, message }) => (
  <span className="gap details open" role="alert" aria-live="polite">
    <div className="usa-alert usa-alert-error" role="alert" aria-live="polite">
      <div className="usa-alert-body">
        <h5 className="usa-alert-heading">{title}</h5>
        <p>{message}</p>
      </div>
    </div>
  </span>
);

PersonsGap.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node,
};

PersonsGap.defaultProps = {
  title: '',
  message: '',
};

export default PersonsGap;
